import React from 'react';
import PropTypes from 'prop-types';
import Wysiwyg from "../wysiwyg/Wysiwyg";

export default function SeoSection({content}) {
  return (
    <Wysiwyg>
      <div dangerouslySetInnerHTML={{
        __html: content
      }}/>
    </Wysiwyg>
  );
}

SeoSection.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./components/seoSection/SeoSection.js